import { Registry } from '@react-registry'

export const boldDeserializer = () => {
  return { bold: true }
}

Registry.register(boldDeserializer, { id: 'B', registry: 'inline-deserializer' })
Registry.register(boldDeserializer, { id: 'STRONG', registry: 'inline-deserializer' })
